<template>
  <div class="left-nav-container">
    <!-- Logo at top -->
    <a
      data-testid="logo-link"
      class="branding"
      href="/"
    >
      <div class="branding__logo">
        Mezmo
      </div>
    </a>

    <!-- Main Navigation Icons -->
    <nav class="nav-icons" aria-label="Main navigation">
      <!-- Home -->
      <button
        class="nav-icon"
        aria-label="Home"
        title="Home"
        disabled
      >
        <elIcon name="home" :custom-size="18" />
      </button>

      <!-- Pipelines -->
      <button
        class="nav-icon"
        aria-label="Pipelines"
        title="Pipelines"
        disabled
      >
        <elIcon name="union" :custom-size="18" />
      </button>

      <!-- Live Tail (Views) -->
      <button
        class="nav-icon"
        aria-label="Live Tail"
        title="Live Tail"
        disabled
      >
        <elIcon name="views" :custom-size="18" />
      </button>

      <!-- Boards (Pulse) - ACTIVE for Investigations -->
      <button
        class="nav-icon active"
        aria-label="Boards"
        title="Boards"
        aria-current="page"
      >
        <elIcon name="pulse" :custom-size="18" />
      </button>

      <!-- Screens -->
      <button
        class="nav-icon"
        aria-label="Screens"
        title="Screens"
        disabled
      >
        <elIcon name="monitor" :custom-size="18" />
      </button>

      <!-- Usage -->
      <button
        class="nav-icon"
        aria-label="Usage"
        title="Usage"
        disabled
      >
        <elIcon name="dashboardB" :custom-size="18" />
      </button>

      <!-- Restore -->
      <button
        class="nav-icon"
        aria-label="Restore"
        title="Restore"
        disabled
      >
        <elIcon name="time-cycle" :custom-size="18" />
      </button>

      <!-- Divider -->
      <div class="nav-divider" />

      <!-- Settings -->
      <button
        class="nav-icon"
        aria-label="Settings"
        title="Settings"
        disabled
      >
        <elIcon name="gear-outline" :custom-size="18" />
      </button>
    </nav>
  </div>
</template>

<script setup>
import elIcon from '@/components/icons/elIcon.vue'
</script>

<style lang="scss" scoped>
// Mezmo SCSS variables are auto-imported via vite.config.js

.left-nav-container {
  display: flex;
  flex-direction: column;
  width: 80px; // $leftNavWidth
  height: 100%;
  background-color: $grey-30;
}

.branding {
  position: relative;
  display: block;
  text-decoration: none;

  &:hover,
  &:focus {
    background-color: rgba(255, 255, 255, 0.05);
  }

  &__logo {
    position: relative;
    left: 5px;
    z-index: 10;
    width: 80px; // $leftNavWidth
    height: 56px; // $headerHeight
    overflow: hidden;
    text-indent: 100%;
    background: url('/mz-star-logo-square-128.png') no-repeat 50% 50%;
    background-size: auto 24px;
    transition: transform 1s ease;
  }
}

.nav-icons {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 0;
  gap: 0.25rem;
  flex: 1;
}

.nav-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  color: $grey-80; // Original Mezmo color - very light gray
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  // Enforce consistent 18px icon sizing
  :deep(svg) {
    width: 18px !important;
    height: 18px !important;
  }

  &:hover:not(:disabled) {
    color: $grey-95; // Almost white on hover
    background-color: $grey-35;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &.active {
    color: #7c82ff; // $accentBlue
    background-color: rgba(124, 130, 255, 0.1);

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 24px;
      background-color: #7c82ff; // $accentBlue
      border-radius: 0 2px 2px 0;
    }
  }

  &:focus-visible {
    outline: 2px solid #7c82ff; // $accentBlue
    outline-offset: 2px;
  }
}

.nav-divider {
  width: 32px;
  height: 1px;
  background-color: $grey-40;
  margin: 0.5rem 0;
}
</style>
